import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui-helpers";
import { StatusBadge } from "@/components/StatusBadge";
import { SendLinkButtons } from "@/components/SendLinkButtons";
import { FileSignature } from "lucide-react";

const STATUS_TONE = { Created: "Draft", Sent: "Sent", "Not delivered": "Overdue", Signed: "Accepted", Countersigned: "Completed" };

export function ClientRetainers({ clientId }) {
  const [list, setList] = useState(null);
  const load = () => api.get(`/clients/${clientId}/retainers`).then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(); }, [clientId]); // eslint-disable-line
  const consult = (list || []).filter((r) => r.kind === "consultation");
  const unsignedConsult = consult.find((r) => !["Signed", "Countersigned"].includes(r.status));
  return (
    <Card className="p-5" data-testid="client-retainers">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div>
          <h3 className="font-head font-bold text-slate-900 flex items-center gap-2"><FileSignature className="h-5 w-5 text-primary" /> Retainers</h3>
          <p className="text-xs text-slate-500 mt-0.5">Consultation retainer — send or resend the signing link in one click.</p>
        </div>
        <SendLinkButtons testid="client-consult-retainer-send" compact onDone={load}
          send={(channel) => api.post(`/clients/${clientId}/consultation-retainer`, { channel, retainer_id: unsignedConsult?.id }).then((r) => r.data)} />
      </div>
      {list && list.length === 0 && <div className="text-sm text-slate-400" data-testid="client-retainers-empty">No retainers yet.</div>}
      <div className="divide-y divide-slate-100">
        {(list || []).map((r) => (
          <div key={r.id} data-testid={`client-retainer-${r.id}`} className="py-2.5 flex flex-wrap items-center gap-2 text-sm">
            <span className="font-semibold text-slate-800">{r.kind === "consultation" ? "Initial Consultation Retainer" : `Case retainer${r.app_number ? ` · ${r.app_number}` : ""}`} v{r.version}</span>
            <span data-testid={`client-retainer-status-${r.id}`}><StatusBadge status={STATUS_TONE[r.status] || r.status} /></span>
            <span className="text-xs text-slate-400">{r.status} · {(r.created_at || "").slice(0, 10)}{r.signature_request?.last_channel ? ` · last ${r.status === "Not delivered" ? "tried" : "sent"} by ${r.signature_request.last_channel}` : ""}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
